import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TelePhoneService {
  private countryCodeStorage: { [instanceId: string]: string } = {};

  setCountryCode(instanceId: string, code: string): void {
    this.countryCodeStorage[instanceId] = code;
  }

  getCountryCode(instanceId: string): string | undefined {
    return this.countryCodeStorage[instanceId];
  }
}
